module.exports = {
  OK: 'OK',
  KO: 'KO',
  PENDING: 'PENDING',
  SYNC: 'SYNC',
  BAD_CREDENTIALS: 'BAD_CREDENTIALS',
  PARTIAL_OK: 'PARTIAL_OK',
  BLOCKED: 'BLOCKED',
  ROBOT_ERROR: 'ROBOT_ERROR',
  SECOND_FACTOR_AUTHENTICATION: 'SECOND_FACTOR_AUTHENTICATION',
  BAD_SECOND_FACTOR_AUTHENTICATION: 'BAD_SECOND_FACTOR_AUTHENTICATION',
  REVIEW: 'REVIEW',
  MULTIPLE_PENDING: 'MULTIPLE_PENDING',
  EXPIRED_SECOND_FACTOR_AUTHENTICATION: 'EXPIRED_SECOND_FACTOR_AUTHENTICATION',
  SECOND_FACTOR_AUTHENTICATION_APP_CONFIRMATION: 'SECOND_FACTOR_AUTHENTICATION_APP_CONFIRMATION',
  PSD2_CONSENT_INVALID: 'PSD2_CONSENT_INVALID',
  PSD2_SESSION_EXPIRED: 'PSD2_SESSION_EXPIRED',
  PENDING_SCRAPING_CREDENTIALS: 'PENDING_SCRAPING_CREDENTIALS',
  MESSAGES_STATUSES: [
    {
      NAME: 'OK',
      TITLE: 'aggregatorStatus-okTitle',
      DESCRIPTION: 'aggregatorStatus-okDescription',
    },
    {
      NAME: 'KO',
      TITLE: 'aggregatorStatus-koTitle',
      DESCRIPTION: 'aggregatorStatus-koDescription',
    },
    {
      NAME: 'PENDING',
      TITLE: 'aggregatorStatus-pendingTitle',
      DESCRIPTION: 'aggregatorStatus-pendingDescription',
    },
    {
      NAME: 'SYNC',
      TITLE: 'aggregatorStatus-syncTitle',
      DESCRIPTION: 'aggregatorStatus-syncDescription',
    },
    {
      NAME: 'PSD2_CONSENT_INVALID',
      TITLE: 'aggregatorStatus-psd2ConsentInvalidTitle',
      DESCRIPTION: 'aggregatorStatus-psd2ConsentInvalidDescription',
      TEXT_PRIMARY_BUTTON: 'aggregatorStatus-psd2ConsentInvalidPrimaryButton',
    },
    {
      NAME: 'BAD_CREDENTIALS',
      TITLE: 'aggregatorStatus-badCredentialsTitle',
      DESCRIPTION: 'aggregatorStatus-badCredentialsDescription',
      TEXT_PRIMARY_BUTTON: 'aggregatorStatus-badCredentialsPrimaryButton',
      URL: '/myprofile/global/entities/credentials/',
    },
    {
      NAME: 'PARTIAL_OK',
      TITLE: 'aggregatorStatus-partialOkTitle',
      DESCRIPTION: 'aggregatorStatus-partialOkDescription',
    },
    {
      NAME: 'BLOCKED',
      TITLE: 'aggregatorStatus-blockedTitle',
      DESCRIPTION: 'aggregatorStatus-blockedDescription',
    },
    {
      NAME: 'ROBOT_ERROR',
      TITLE: 'aggregatorStatus-robotErrorTitle',
      DESCRIPTION: 'aggregatorStatus-robotErrorDescription',
    },
    {
      NAME: 'SECOND_FACTOR_AUTHENTICATION',
      TITLE: 'aggregatorStatus-secondFactorAuthTitle',
      DESCRIPTION: 'aggregatorStatus-secondFactorAuthDescription',
      TEXT_PRIMARY_BUTTON: 'aggregatorStatus-secondFactorAuthPrimaryButton',
      TEXT_SECOND_BUTTON: 'aggregatorStatus-secondFactorAuthSecondButton',
      URL: '/myprofile/global/entities/manage/credentials/',
    },
    {
      NAME: 'REVIEW',
      TITLE: 'aggregatorStatus-reviewTitle',
      DESCRIPTION: 'aggregatorStatus-reviewDescription',
    },
    {
      NAME: 'MULTIPLE_PENDING',
      TITLE: 'aggregatorStatus-multiplePendingTitle',
      DESCRIPTION: 'aggregatorStatus-multiplePendingDescription',
      TEXT_PRIMARY_BUTTON: 'aggregatorStatus-multiplePendingPrimaryButton',
      TEXT_SECOND_BUTTON: 'aggregatorStatus-multiplePendingSecondButton',
    },
    {
      NAME: 'EXPIRED_SECOND_FACTOR_AUTHENTICATION',
      TITLE: 'aggregatorStatus-expiredSecondFactorTitle',
      DESCRIPTION: 'aggregatorStatus-expiredSecondFactorDescription',
      TEXT_PRIMARY_BUTTON: 'aggregatorStatus-expiredSecondFactorPrimaryButton',
      TEXT_SECOND_BUTTON: 'aggregatorStatus-expiredSecondFactorSecondButton',
      URL: '/myprofile/global/entities/manage/credentials/',
    },
    {
      NAME: 'SECOND_FACTOR_AUTHENTICATION_APP_CONFIRMATION',
      TITLE: 'aggregatorStatus-secondFactorAuthenticationAppConfirmationTitle',
      DESCRIPTION: 'aggregatorStatus-secondFactorAuthenticationAppConfirmationDescription',
    },
    {
      NAME: 'BAD_SECOND_FACTOR_AUTHENTICATION',
      TITLE: 'aggregatorStatus-badSecondPhaseTitle',
      DESCRIPTION: 'aggregatorStatus-badSecondPhaseDescription',
      TEXT_PRIMARY_BUTTON: 'aggregatorStatus-badSecondPhasePrimaryButton',
      TEXT_SECOND_BUTTON: 'aggregatorStatus-expiredSecondFactorSecondButton',
      URL: '/myprofile/global/entities/manage/credentials/',
    },
    {
      NAME: 'PSD2_SESSION_EXPIRED',
      TITLE: 'aggregatorStatus-sessionExpiredTitle',
      DESCRIPTION: 'aggregatorStatus-sessionExpiredDescription',
      TEXT_PRIMARY_BUTTON: 'aggregatorStatus-sessionExpiredPrimaryButton',
      URL: '/myprofile/global/entities/add/credentials/',
    },
    {
      NAME: 'PENDING_SCRAPING_CREDENTIALS',
      TITLE: 'aggregatorStatus-pendingScrapingCredentialsTitle',
      DESCRIPTION: 'aggregatorStatus-pendingScrapingCredentialsDescription',
      TEXT_PRIMARY_BUTTON: 'aggregatorStatus-pendingScrapingCredentialsPrimaryButton',
      URL: '/myprofile/global/entities/add/credentials/scrapping/',
    },
  ],
};
